
import { supabase } from '../../supabase';
import { AggregateBy, PageStat, ActionStat } from '../types';
import { AuthFilter } from '@/components/analytics/AuthFilterButtons';

/**
 * Generic query for page or action stats
 */
export const getGenericStats = async (
  startDate: Date, 
  endDate: Date, 
  groupBy: AggregateBy,
  authFilter: AuthFilter = 'all'
): Promise<PageStat[] | ActionStat[]> => {
  // Determine which RPC function to call
  const rpcFunction = groupBy === 'page_path' 
    ? 'get_page_stats_aggregated' 
    : 'get_action_stats_aggregated';

  const { data, error } = await supabase.rpc(rpcFunction, {
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString(),
    auth_filter: authFilter
  });
  
  if (error) {
    console.error(`Error fetching ${groupBy} stats:`, error);
    throw error;
  }

  // Format based on the groupBy field
  if (groupBy === 'page_path') {
    return (data || []).map(item => ({
      page_path: item.page_path,
      count: Number(item.count)
    })) as PageStat[];
  } else if (groupBy === 'action_type') {
    return (data || []).map(item => ({
      action_type: item.action_type,
      count: Number(item.count)
    })) as ActionStat[];
  }
  
  throw new Error(`Unsupported groupBy value: ${groupBy}`);
};
